import { render } from "./CloseBtn.vue?vue&type=template&id=45e06b3b&scoped=true"
import script from "./CloseBtn.vue?vue&type=script&lang=js"
export * from "./CloseBtn.vue?vue&type=script&lang=js"

import "./CloseBtn.vue?vue&type=style&index=0&id=45e06b3b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e06b3b"]])

export default __exports__